import React from 'react';
import ReactDOM from 'react-dom/client';
import "./index.scss";
import App from './App';
import { AuthProvider } from './context/AuthProvider';
import { QueryProvider } from './context/QueryProvider';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import "primereact/resources/themes/lara-light-indigo/theme.css";  //theme
import "primereact/resources/primereact.min.css";                  //core css
import "primeicons/primeicons.css";                                //icons

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
   <BrowserRouter>
    <AuthProvider>
      <QueryProvider>
        <Routes>
          <Route path="/*" element={<App />} />
        </Routes>
      </QueryProvider>
    </AuthProvider>
  </BrowserRouter>
  <div id="page-loader" className="page-loader">
    <div className="cube-wrapper">
    <div className="cube-folding">
        <span className="leaf1"></span>
        <span className="leaf2"></span>
        <span className="leaf3"></span>
        <span className="leaf4"></span>
    </div>
    <span className="loading" data-name="loading">Processing</span>
    </div>
    </div>
  </>
 
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
